import type { SVGProps } from "react";

/** Icono correo; el `<svg>` es la raíz para que `Button` y `[&>svg]` reciban tamaño/color. */
export default function Mail({
  className = "h-5 w-5 shrink-0",
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      fill="currentColor"
      className={className}
      aria-hidden
      {...props}
    >
      <path
        d="M3.293 40.707V7.265h41.442v33.442H3.293zM24 25.805l16.746-11.15v-3.4L24 22.154l-16.746-10.9v3.4L24 25.805z"
      />
    </svg>
  );
}
